export default __webpack_public_path__ + "static/media/usa_flag.0008011f.png";